<template>
    <Card title="appointments.members" titleClass="fw-bolder fs-1"  containerClass="shadow-sm h-500px" >
        <template #cardToolbar>
            <div class="mt-7">
                <Button  v-if="$can(abilities.UPDATE_APPOINTMENT) || $can(abilities.UPDATE_ALL_APPOINTMENT)" type="new" v-show="appointment.status != 'CANCELLED' && appointment.status != 'COMPLETED'" @click="addParticipants" btn-class="btn-sm" btn-text="appointments.add" ></Button>
            </div>
        </template>
        <template #cardBody>
            <div class="card p-5" style="background-color: #0072CE0D;">
                <div class="d-flex flex-wrap">
                    <span class="p-2 mb-3 text-center me-3" :class="'badge badge-light-'+getStatusColor(member.status)" v-for="(member, index) in participants" :key="index">{{ member.name ? member.name : member.email}}</span>
                </div>
                
                <div class="mt-5">
                    <h6>{{ $t('appointments.legend') }}</h6>
                    <div class="d-flex flex-wrap align-items-center">
                        <div class="d-flex align-items-center me-4 mb-2" v-for="(statusVal, index) in availableStatus" :key="index">
                            <div :class="'bg-'+statusVal.color" style="width: 20px; height: 5px;"></div>
                            <span class="ms-2" :class="'text-'+statusVal.color">{{statusVal[locale]}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Card> 
</template>

<script setup>
import Card from "@/Modules/CRM/components/Card";
import Button from "@/components/Button.vue";
import {ref, watch, onMounted, computed} from "vue";
import {useStore} from "vuex";
import {useLocales} from "@/composables/locales";
import abilities from "@/composables/abilities";

const {locale} = useLocales()
const store = useStore()

const props = defineProps({
  appointment: Object
})

function addParticipants(){
    $('#addParticipantModal').modal('toggle')
}

const participants = ref([])

const availableStatus = computed(() => store.getters['appointments/getAvailableStatus'])

watch(() => props.appointment, (newValue) => {
    let data = []
    if(newValue){
        newValue.participants?.filter((item) => {
            data.push({name: item?.participant?.fullname, email: item?.participant?.email, status: item?.available_status})
        })
    }
    participants.value = data
})

onMounted(() => {
    store.dispatch('appointments/loadAvailableStatus')
})

function getStatusColor(val){
    let color = availableStatus.value.filter(el => el.value === val)[0]?.color || 'warning'
    return color
}
</script>